export function isMobileViewport(): boolean {
  return window.innerWidth < 768;
}
